// This file is used to import Swiper JS library and is required for Swiper to work.
;(() => {
  requestAnimationFrame(() => {
    import('@theme/vendor-swiper-element').then(({ register }) => {
      requestAnimationFrame(() => {
        register()
      })
    })
  })
})()
